/**
 * Week ID helpers — kept byte-for-byte identical to the implementation in
 * `functions/captureUserIP.js` (lines 41 + 649–655) so that server and
 * client agree on the week ID for the same instant. If you ever change
 * the algorithm here, change it there in the same commit.
 *
 * Format: `YYYY-Www` where `ww` is the ISO week number, zero-padded.
 *   Examples: `2026-W17`, `2026-W01`.
 *
 * Note: the year segment intentionally uses local `getFullYear()` (matching
 * captureUserIP.js) even though `getWeekNumber` is computed in UTC. This
 * can produce minor mismatches at year boundaries (Dec 31 / Jan 1) — but
 * that's the existing behavior shared by every consumer of `lastActiveWeek`,
 * so we preserve it intentionally.
 */

export const getWeekNumber = (date) => {
  const d = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
  const dayNum = d.getUTCDay() || 7;
  d.setUTCDate(d.getUTCDate() + 4 - dayNum);
  const yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
  return Math.ceil((((d - yearStart) / 86400000) + 1) / 7);
};

export const getCurrentWeekId = () => {
  const now = new Date();
  const weekNumber = getWeekNumber(now);
  return `${now.getFullYear()}-W${String(weekNumber).padStart(2, '0')}`;
};
